import CatalogueItemPreviewModal from './CatalogueItemPreviewModal';

export default CatalogueItemPreviewModal;
